import createDOMPurify from 'dompurify';

/**
 * Email HTML comes from outside, so nothing renders until it passes through
 * here. Images are dropped because a remote one reports to its sender when a
 * staff member opens the email (attachments still list inline files). Inline
 * styles and forms are dropped so a message can't restyle or imitate the admin.
 */
const purify = createDOMPurify(window);

purify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const CONFIG = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ['style', 'img', 'picture', 'video', 'audio', 'form', 'input', 'button', 'select', 'textarea', 'svg', 'math'],
  FORBID_ATTR: ['style', 'class', 'id', 'srcset'],
};

export function sanitizeEmailHtml(html: string | null | undefined): string {
  return html ? purify.sanitize(html, CONFIG) : '';
}

/** Sanitised HTML as readable text, for previews, translation and forwards. */
export function emailHtmlToText(html: string | null | undefined): string {
  const clean = sanitizeEmailHtml(html);
  if (!clean) return '';
  const spaced = clean
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|tr|h[1-6]|blockquote)>/gi, '$&\n');
  const text = new DOMParser().parseFromString(spaced, 'text/html').body.textContent || '';
  return text
    .replace(/\u00a0/g, ' ')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
